import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/http/api.service';
import { IOcbFileTransferStatistic } from '@app/core/models/api/IOcbFileTransferStatistic';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IOcbPlatformsRelation } from '../models';
import { ImageService } from './image.service';

@Injectable()
export class StatisticsService extends ApiService {

    private statisticsUrl: string;

    private options = {
        headers: this.defaultHeaders,
        observe: 'body' as 'body',
    };

    constructor(httpClient: HttpClient, private imageService: ImageService) {
        super(httpClient);

        if (!environment.api.endpoint) {
            throw new Error('Could not initialize the "file-transfers" service, the proxyPath configuration is invalid.');
        }

        this.statisticsUrl = `${environment.api.endpoint}/statistics`;
    }

    /**
     * Get the list of relations between platforms
     * @param environmentId Internal identifier of the environment
     */
    public getPlatformsRelations(environmentId?: string): Observable<IOcbPlatformsRelation[]> {

        let url = `${this.statisticsUrl}/platforms/relations`;

        if (environmentId) { url = `${url}?EnvironmentId=${environmentId}`; }

        return this.httpClient.get<IOcbPlatformsRelation[]>(url, this.options);
    }

    /**
     * Get the list of file transfers
     * @param environmentId Internal identifier of the environment
     * @param fileTransferId Internal identifier of the file transfer
     */
    public getFileTransfersStatistics(environmentId?: string, fileTransferId?: string): Observable<IOcbFileTransferStatistic[]> {

        let url = `${this.statisticsUrl}/transfers?`;

        if (environmentId) { url = `${url}EnvironmentId=${environmentId}`; }
        if (fileTransferId) {
            if (environmentId) url = `${url}&FileTransferId=${fileTransferId}`;
            else url = `${url}FileTransferId=${fileTransferId}`;
        }

        return this.httpClient.get<IOcbFileTransferStatistic[]>(url, this.options);
    }

}
